/* ===========================================================================
   ESCALERA DE CARRITO — la parte que Liquid no puede hacer.
   ---------------------------------------------------------------------------
   Liquid (snippets/escalera-carrito.liquid) ya dibuja el mensaje y la barra, y
   se recalcula solo porque Dawn reemplaza .drawer__inner en cada cambio.
   Este archivo hace SÓLO dos cosas:
     1. aplicar el código de descuento del escalón alcanzado,
     2. meter / sacar el regalo.
   NO hay botón: la cantidad se sube con el stepper nativo del carrito.
   Es genérico: no sabe nada de ningún producto. Todo sale de los data-* que
   imprime el snippet desde el metafield escalera.config de cada producto.
   =========================================================================== */
(function () {
  'use strict';
  if (window.__escaleraCarrito) return;
  window.__escaleraCarrito = true;

  var PROP = '_escalera_regalo'; // marca la línea del regalo; así no necesito estado global
  var sincronizando = false;
  var ultimoCodigo = null;

  function cart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) { return r.json(); });
  }

  // Repinta el drawer y la burbuja sin recargar la página.
  function repintar() {
    return fetch('/?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var dp = new DOMParser();
        if (j['cart-drawer']) {
          var nuevo = dp.parseFromString(j['cart-drawer'], 'text/html').querySelector('.drawer__inner');
          var actual = document.querySelector('.drawer__inner');
          if (nuevo && actual) actual.innerHTML = nuevo.innerHTML;
        }
        if (j['cart-icon-bubble']) {
          var nb = dp.parseFromString(j['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
          var ab = document.getElementById('cart-icon-bubble');
          if (nb && ab) ab.innerHTML = nb.innerHTML;
        }
      })
      .catch(function () {});
  }

  function lineaRegalo(c) {
    for (var i = 0; i < c.items.length; i++) {
      var p = c.items[i].properties;
      if (p && (p[PROP] || p[PROP] === '1')) return c.items[i];
    }
    return null;
  }

  function sync() {
    if (sincronizando) return Promise.resolve();
    sincronizando = true;

    return cart()
      .then(function (c) {
        var el = document.querySelector('[data-escalera]');
        var regalo = lineaRegalo(c);

        // Variante del regalo y si corresponde tenerlo, según lo que dijo Liquid.
        var variante = el ? parseInt(el.getAttribute('data-regalo-variant') || '0', 10) : 0;
        var corresponde = !!(el && el.getAttribute('data-regalo-activo') === '1' && variante);

        // Nadie se lleva el regalo solo.
        if (regalo && c.items.length === 1) corresponde = false;

        if (corresponde && !regalo) {
          var props = {};
          props[PROP] = '1';
          return post('/cart/add.js', { items: [{ id: variante, quantity: 1, properties: props }] })
            .then(function () { return true; });
        }
        if (!corresponde && regalo) {
          return post('/cart/change.js', { id: regalo.key, quantity: 0 }).then(function () { return true; });
        }
        // El regalo quedó con cantidad > 1 (p.ej. el cliente la subió a mano).
        if (corresponde && regalo && regalo.quantity > 1) {
          return post('/cart/change.js', { id: regalo.key, quantity: 1 }).then(function () { return true; });
        }
        return false;
      })
      .then(function (cambio) {
        // El código del escalón alcanzado. Si el carrito baja, Shopify lo
        // invalida solo por el mínimo de cantidad — no hay que "desaplicarlo".
        var el = document.querySelector('[data-escalera]');
        var codigo = el ? (el.getAttribute('data-codigo') || '') : '';
        if (codigo && codigo !== ultimoCodigo) {
          ultimoCodigo = codigo;
          return fetch('/discount/' + encodeURIComponent(codigo), { method: 'GET' })
            .catch(function () {})
            .then(function () { return true; });
        }
        return cambio;
      })
      .then(function (cambio) {
        sincronizando = false;
        if (cambio) return repintar().then(marcarRegalo);
        marcarRegalo();
      })
      .catch(function () { sincronizando = false; });
  }

  // (Sin botón: el mensaje sólo informa y la cantidad se sube con el stepper nativo
  //  del carrito. Decisión del usuario 2026-10-19.)

  // La línea del REGALO no lleva selector de cantidad ni botón de quitar: es un regalo,
  // no un producto que el cliente elija. Sólo esa línea — la del producto sí lo conserva,
  // porque subirla es justamente como se desbloquea el regalo.
  // Dawn pone data-quantity-variant-id en el input de cantidad de cada fila.
  function marcarRegalo() {
    var el = document.querySelector('[data-escalera]');
    if (!el) return false;
    var v = el.getAttribute('data-regalo-variant');
    if (!v) return false;
    var tocado = false;
    var inputs = document.querySelectorAll('#CartDrawer [data-quantity-variant-id="' + v + '"]');
    for (var i = 0; i < inputs.length; i++) {
      var fila = inputs[i].closest('.cart-item');
      if (!fila || fila.getAttribute('data-esc-regalo') === '1') continue;
      fila.setAttribute('data-esc-regalo', '1');
      tocado = true;
      var qp = fila.querySelector('quantity-popover') || fila.querySelector('.cart-item__quantity-wrapper');
      if (qp) qp.style.display = 'none';
      var rm = fila.querySelector('.cart-remove-button');
      if (rm) rm.style.display = 'none';
      var celda = fila.querySelector('.cart-item__quantity');
      if (celda && !celda.querySelector('.esc-tag')) {
        var tag = document.createElement('span');
        tag.className = 'esc-tag';
        tag.textContent = '\uD83C\uDF81 Regalo';
        celda.appendChild(tag);
      }
    }
    return tocado;
  }

  // Dawn reemplaza .drawer__inner con innerHTML, y eso NO re-ejecuta scripts.
  // Por eso este archivo se carga una sola vez fuera de esa zona y se entera de
  // los cambios observando el DOM.
  function observar() {
    var cont = document.getElementById('CartDrawer');
    if (!cont) return;
    var t = null;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(sync, 120);
    }).observe(cont, { childList: true, subtree: true });
  }

  function init() { observar(); sync(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
